import { number } from "yup";

const NUMBER_GROUP_PATTERN = /^\d{1,3}( \d{3})*(\.\d+)?$/; // 1 000 000 000
const INTL_PHONE_PATTERN = /^(\+\d{1,3})(\d{3})(\d{3})(\d{4})$/; // +12345678901
const LOCAL_PHONE_PATTERN = /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/; // 0612345678
const OTHER_PHONE_PATTERN = /(\d{3})(?=\d)/g; // 1234567890
export const LOCAL_CURRENCY = { style: 'currency', currency: 'XOF' } as Intl.NumberFormatOptions;

export class SoNumber {

    static formatNumberGroup = (value: string | number) => {

        if (!value || String(value).length === 0 || NUMBER_GROUP_PATTERN.test(String(value))) {
            return value;
        }

        // Supprime tout sauf chiffres et séparateurs existants
        const onlyNumbers = String(value).replace(/[^\d.,]/g, '');
        // Remplace virgule par point si nécessaire, tu peux l'adapter
        const normalized = onlyNumbers.replace(',', '.');
        // Sépare par milliers
        const parts = normalized.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return parts.join('.');
    }

    static unGroup = (formatted: string): number => {
        const raw = String(formatted).replace(/[^\d,.-]/g, '').replace(',', '.');//.replace(/\s/g, '');
        return raw.length > 0 ? parseFloat(raw) : 0;
    }

    static group = (value: string | number): string => {
        return String(value)?.length >= 3 ? "" + SoNumber.formatNumberGroup(value) : String(value);
    }


    /**
     * Exemple : FormatNumberHelper.toFR(0, { style: 'currency', currency: 'EUR' }); 
     * Result : "0,00 €"
     * @param value 
     * @param options 
     * @returns 
     */
    static toFR = (value?: string | number | null, options?: Intl.NumberFormatOptions): string => {

        const numericValue = typeof value === 'string' ? parseFloat(value) : value;

        if (typeof numericValue !== 'number' || isNaN(numericValue)) {
            return '';
        }

        return new Intl.NumberFormat('fr-FR', options).format(numericValue);
    };



    static isIntlPhone = (phone: string) => {
        return phone.startsWith('+');
    }

    static phone = (value?: string | number | null): string => {
        if (!value) return "";

        let raw = String(value).trim();

        // Autoriser un + en début, sinon supprimer tout sauf chiffres
        //const isInternational = raw.startsWith('+');
        let cleaned = raw.replace(/[^\d]/g, '');
        if (this.isIntlPhone(raw)) {
            cleaned = '+' + cleaned;
        }

        // Si le contenu est invalide, on retourne tel quel
        if (!/^(\+?\d+)$/.test(cleaned)) {
            return raw;
        }

        // Tentative de formatage générique par bloc de 2 ou 3 chiffres
        let formatted = cleaned;

        // Si international (commence par +)
        if (this.isIntlPhone(cleaned)) {
            // Essayons : indicatif + bloc de 3 / 3 / 4 pour numéros courants
            // Exemple : +12345678901 → +1 234 567 8901
            formatted = cleaned.replace(INTL_PHONE_PATTERN, '$1 $2 $3 $4');
        }
        // Sinon local : on part sur bloc de 2 chiffres (FR-like)
        else if (cleaned.length === 10) {
            // 0612345678 → 06 12 34 56 78
            formatted = cleaned.replace(LOCAL_PHONE_PATTERN, '$1 $2 $3 $4 $5');
        }
        // Autres cas → on tente un découpage en blocs de 3
        else if (cleaned.length >= 7 && cleaned.length <= 13) {
            // Découpage générique : 1234567890 → 123 456 7890
            formatted = cleaned.replace(OTHER_PHONE_PATTERN, '$1 ').trim();
            if (this.isIntlPhone(raw)) {
                formatted = '+' + formatted.replace(/^\+/, '');
            }
        }

        return formatted;
    }

    static percent(value: number): string {
        return (value === null || value === undefined) ? "" : String(number) + "%";
    }

    static formatAmount = (value: string | number | null | undefined) => {
        if (!value) return '';
        return value.toString().replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    static parceAmout = (value?: string | null) => value ? Number(value.replace(/\s/g, '') ?? 0) : 0;

    static toNumber = (value?: string): number | undefined => {
  const n = Number(value)
  return Number.isFinite(n) ? n : undefined
}
}